







































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import { inputNames, previewName } from '@/constants/docurain/docurain';

interface FormInputs {
  text?: string
  value?: string
  data?: {[k: string]: string}[]
}
interface SelectData {
  color: string
  display_id: string
  enabled: boolean
  option_id: string
  sort_id: number
  text: string
  value:string
}
@Component({
  components:{ AutoCreateForm }
})
export default class DialogFormOutput extends Vue {
  // ダイアログ開閉状態
  @Prop({ default: false })
  private dialog?: boolean;
  // ダイアログ内表示タイトル
  @Prop({ default: '' })
  private title!: string;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // ダイアログ内ボタンをテキストに変更
  @Prop({ default: false })
  private isTextActionButton?: boolean;
  // ダイアログ内NGボタン文字
  @Prop({ default: 'キャンセル' })
  private buttonTextNG?: string;
  // ダイアログ内OKボタン文字
  @Prop({ default: 'OK' })
  private buttonTextOK?: string;
  // ダイアログ内NGボタン文字色
  @Prop({ default: 'light' })
  private buttonColorNG?: string;
  // ダイアログ内OKボタン文字色
  @Prop({ default: 'primary' })
  private buttonColorOK?: string;
  // OKボタンを表示するか
  @Prop({ default: true })
  private isDisplayOk?: boolean;
  // キャンセルボタンを表示するか
  @Prop({ default: true })
  private isDisplayCancel?: boolean;
  // フォーム自動生成入力要素一覧
  @Prop({default: () => ([])})
  private fieldData!: Array<{[k: string]: any}>;
  // フォーム自動生成カラムスタイル情報
  @Prop({default: ''})
  private fieldCols!: string;
  // 帳票テンプレート一時保存
  @Prop({default: () => ([])})
  private formTemplateList!: {[k: string]: any}[];
  @Prop({default: false})
  private isLoading?: boolean

  // 入力データ
  private formInputData: {[k: string]: FormInputs} = {}

  // アラート表示関連
  @Prop({default: false})
  private isAlert?: boolean;
  @Prop({default: ''})
  private alertMessage?: string;
  @Prop({default: 'error'})
  private alertStyle?: string;

  @Watch('fieldData')
  watchFieldData() {
    if (this.fieldData.length > 0) {
      this.fieldData.forEach(field => {
        if(field.props.value && field.props.value.length > 0){
          let text = field.props.value;

          if (field.props.selectData !== undefined && field.props.selectData.options !== undefined) {
            const targetOption = field.props.selectData.options.find((option: {[k:string]: string}) => {
              return option.value === field.props.value;
            });
            if (targetOption) {
              text = targetOption.text;
            }
          }
          // 初期VALUEを投げる
          this.catchInput({
            name: field.props.name,
            value: field.props.value,
            text: text
          });
        }
      })
    }
  }

  /**
   * 各要素の入力値取得、処理
   */
  private catchInput(data: any): void {

    if (data.name === previewName && !data.value) {
      const matchIndex = this.fieldData.findIndex(f => f.display_id === data.name);
      if (matchIndex > -1) {
        const prev = this.fieldData[matchIndex];
        prev.props!['srcList'] = [];
        this.$set(this.fieldData, matchIndex, prev);
      }
    }

    if (data.name === previewName && data.value) {
      this.getPreView();
      return;
    }

    const inputObject: FormInputs = {};
    inputObject['text'] = data.text ? data.text : null;
    inputObject['value'] = data.value ? data.value : null;
    inputObject['data'] = data.data ? data.data : null;
    this.formInputData[data.name] = inputObject;

    if (data.data !== undefined && data.data.length === 0) {
      delete this.formInputData[data.name];
    }

    this.searchOption(data);
    this.checkInput();

  }

  /**
   * 要素が選択された際の処理を記述
   * @param data 入力データ
   * @returns void
   */
  private searchOption(data: any): void {

    switch(data.name) {
      // 出力形式が変更されたら「作成帳票」「帳票テンプレート」初期化
      // 「作成帳票」を絞り込み
      case inputNames.format :{
        this.clearSelect([inputNames.type, inputNames.templateName]);
        const matchIndex = this.fieldData.findIndex(f => f.display_id === inputNames.type);
        if (matchIndex > -1) {
          const props = this.fieldData[matchIndex].props;
          props.isDisabled = false;
          const replaceList = this.formTemplateList.filter(option => {
            return option[data.value] !== undefined;
          });
          props.selectData.options = replaceList;
          props.value = replaceList[0].value;
          this.formInputData[inputNames.type] = { value: replaceList[0].value };
          this.$set(this.fieldData[matchIndex], 'props', props);
        }
        break;
      }

      default :
        break;
    }
  }

  /**
   * セレクト要素を初期化する
   * @param targetList 初期化対象の要素Name（配列）
   */
  private clearSelect(targetList: string[]): void {

    for (const i in targetList) {
      const matchIndex = this.fieldData.findIndex(f => f.display_id === targetList[i]);
      if (matchIndex > -1) {
        let props = this.fieldData[matchIndex].props;
        props = {
          ...props,
          ...{
            isDisabled: true,
            arrayValue: [],
            selectData: {
              options: []
            }
          }
        }
        this.$set(this.fieldData[matchIndex], 'props', props);
        delete this.formInputData[targetList[i]]
      }
    }

  }

  /**
   * 要素の入力を確認しプレビューボタンのdisableを変更する
   */
  private checkInput(): void {
      const targetFields = this.fieldData.filter(v => v.display_id !== previewName).map(v => v.display_id);
      const diff = targetFields.filter(i => Object.keys(this.formInputData).indexOf(i) == -1)

      if (diff.length ===  8) {
        this.allowClick(true);
      } else {
        this.allowClick(false);
      }

  }
  private allowClick(status: boolean): void  {
    const matchIndex = this.fieldData.findIndex(f => f.display_id === previewName);
    if (matchIndex > -1) {
      const prev = this.fieldData[matchIndex];
      prev.props!['isDisabled'] = !status;
      this.$set(this.fieldData, matchIndex, prev);
    }
  }

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module addDetailsOpratipon
   * @return {AddDetailResponse} - 要素ステータス、押下判定
   */
  @Emit('confirmOpratipon')
  public confirmOpratipon(isAgree: boolean): { [k:string]: any} {
    return {isAgree: isAgree, data: this.formInputData};
  }

  /**
   * プレビューボタンを押下した通知を親コンポーネントに通知する
   * @return  要素ステータス、押下判定
   */
  @Emit('getPreView')
  public getPreView(): { [k:string]: any}  {
    return {data: this.formInputData};
  }

}
